<template>
  <div v-if="visible">
    <img src='../../assets/loader.svg' />
  </div>
</template>
<script>
//////////////////////////////////////
// IMPORT
/////////////////////////////////////
import ScaleSpinner from '@/components/loaders/ScaleSpinner'
//////////////////////////////////////
// CLASS
/////////////////////////////////////
export default {
  name: 'loader',
  components: {
    ScaleSpinner
  },
  beforeCreate () {
  },
  created () {
  },
  beforeMount () {
  },
  mounted () {
  },
  beforeUpdate () {
  },
  updated () {
  },
  beforeDestroy () {
  },
  destroyed () {
  },
  data () {
    return {}
  },
  props: {
    loader: null,
    label: {
      type: String,
      default: 'Loading...'
    },
    visible: {
      type: Boolean,
      default: true
    }
  },
  computed: {},
  methods: {},
  watch: {}
}
</script>




// WEBPACK FOOTER //
// src/components/loaders/Loader.vue